// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"5e2defad","217":"5707acc9","241":"c2c97533","443":"0a4cc2ac","451":"83bafb86","488":"cf94fb66","655":"241c7e29","938":"441e5d4c"}[chunkId] + ".chunk.js";
};